import Vue from 'vue';
import Vuetify, {
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
  VSpacer,
  VBtn,
  VProgressLinear,
  VIcon,
  VTextField,
  VFlex,
  VContainer,
  VLayout,
  VForm,
  VList,
  VListItem,
  VSnackbar,
  VSkeletonLoader,
  VAutocomplete,
  VCol,
  VRow,
  VListItemAvatar,
  VListItemContent,
  VListItemTitle,
  VListItemSubtitle,
  VImg,
  VDivider,
  VListItemAction,
  VNavigationDrawer,
  VMenu,
} from 'vuetify/lib';

Vue.use(Vuetify, {
  components: {
    VAutocomplete,
    VCard,
    VCardActions,
    VCardText,
    VCol,
    VRow,
    VDialog,
    VCardTitle,
    VSpacer,
    VBtn,
    VProgressLinear,
    VIcon,
    VTextField,
    VFlex,
    VContainer,
    VLayout,
    VForm,
    VList,
    VListItem,
    VListItemAvatar,
    VListItemContent,
    VListItemTitle,
    VListItemSubtitle,
    VSnackbar,
    VSkeletonLoader,
    VImg,
    VDivider,
    VListItemAction,
    VNavigationDrawer,
    VMenu,
  },
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#4caf50',
        secondary: '#2196f3',
        accent: '#607d8b',
        error: '#f44336',
        warning: '#ffc107',
        info: '#3f51b5',
        success: '#8bc34a',
      },
      dark: {
        primary: '#3D6A8C',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
